"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubOriginePatrimoineCorporation = void 0;
exports.ESubOriginePatrimoineCorporation = {
    salaire: "salaire",
    creation_valorisation_entreprise: "creation_valorisation_entreprise",
    heritage: "heritage",
};
